/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import rest from '../../../../client/js/lib/rest'
import { HalDocument } from '@jalik/hal'

export function deleteProspecting (id: number) {
  return rest.delete(`/api/prospecting/${id}`)
}

export function fetchProspecting (id: number): Promise<Prospecting> {
  return rest.get(`/api/prospecting/${id}`)
    .then((resp) => resp.json())
}

export function findManyProspecting (params?: Record<string, any>): Promise<HalDocument<{
  prospecting: Prospecting[]
}>> {
  return rest.get(`/api/prospecting?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function findManyProspectingMatchingEstateId (params?: Record<string, any>): Promise<HalDocument<{
  prospecting: Prospecting[]
}>> {
  return rest.get(`/api/estates/${params.estateId}/prospecting?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function patchProspecting (id: number, data: Partial<Prospecting>) {
  return rest.patch(`/api/prospecting/${id}`, {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}

export function postProspecting (data: Partial<Prospecting>) {
  return rest.post('/api/prospecting', {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}
